import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";

export default function AIMenuItems({ menuItems }) {
  return (
    <Box sx={{ p: 2, flex: 1, overflowY: "auto" }}>
      <Grid container spacing={2}>
        {menuItems.map((item, index) => (
          <Grid item xs={12} key={index}>
            <Card
              sx={{
                borderRadius: 2,
                boxShadow: 2,
                "&:hover": { boxShadow: 4 },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", lineHeight: 1.3 }}
                    >
                      {item.traditional_chinese_name}
                    </Typography>

                    {item.pinyin && (
                      <Typography
                        variant="subtitle2"
                        sx={{ fontStyle: "italic", color: "text.secondary" }}
                      >
                        {item.pinyin}
                      </Typography>
                    )}

                    {item.english_translation && (
                      <Typography variant="body1" sx={{ mt: 0.5 }}>
                        {item.english_translation}
                      </Typography>
                    )}
                  </Box>

                  {item.price !== undefined && (
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                        ml: 2,
                      }}
                    >
                      NT$ {item.price}
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
